import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDocumentTypeField, updateDocumentTypeField, deleteDocumentTypeField } from '../../../../api/administration/edmsSettings/documentTypeFields';

export const useDocumentTypeFieldMutations = (queryKey = ['documentTypeFields']) => {
  const queryClient = useQueryClient();

  const invalidateDocumentTypeFields = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
    await queryClient.invalidateQueries({ queryKey: ['documentTypeFields', 'active'], exact: false });
  };

  const createMutation = useMutation({
    mutationFn: createDocumentTypeField,
    onSuccess: () => invalidateDocumentTypeFields(),
  });

  const updateMutation = useMutation({
    mutationFn: updateDocumentTypeField,
    onSuccess: () => invalidateDocumentTypeFields(),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteDocumentTypeField,
    onSuccess: () => invalidateDocumentTypeFields(),
  });

  return {
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export default useDocumentTypeFieldMutations;
